import classNames from 'classnames';
import { FC, useCallback, useContext } from 'react';
import { useIntl } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

type ApplyButtonProps = {
  className?: string;
  onApply?: () => void;
};
export const ApplyButton: FC<ApplyButtonProps> = ({ className, onApply }) => {
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  const onClick = useCallback(() => {
    if (onApply) {
      onApply();
      logAnalytics.trackEvent(logAnalyticsCategory, 'Apply price improvement');
    }
  }, [logAnalyticsCategory, onApply]);

  const { formatMessage } = useIntl();

  return (
    <button
      className={classNames('btn btn-discreet-info btn-lg my-0', className)}
      data-e2e="price-negotiation-apply-btn"
      onClick={onApply && onClick}
      disabled={!onApply}
      type="button"
    >
      {formatMessage({ id: 'priceImprovement.apply.button.label' })}
    </button>
  );
};
